module.exports = __webpack_public_path__ + "img/protester(1).68ecde0f.png";